import type { CreateInput } from "@/commands/create/create-input";
/**
 * Validated locally so a typo names itself, instead of travelling to the API
 * and coming back as a bare "Input validation failed" that says nothing about
 * which flag was wrong.
 *
 * `satisfies` against the router's own input type is what keeps these lists
 * honest: adding a task type server-side without updating this one is a
 * `types:check` failure, not a CLI that quietly refuses a valid value.
 */
export const TASK_TYPES = [
  "implement",
  "new-project",
  "orchestrator",
  "design",
  "automate",
] as const satisfies readonly NonNullable<CreateInput["taskType"]>[];
